import useTranslation from 'next-translate/useTranslation'

import Arrow from '@/atoms/Arrow/Arrow'
import PointsLine from '@/atoms/PointsLine/PointsLine'

import { getLine } from '../logic'

function WithLineSection() {
  const { t } = useTranslation('forCreators')
  const line = getLine(t)

  return (
    <div className="flex flex-col py-8 space-y-16 md:space-y-0 lg:flex-row md:p-12 lg:p-16">
      <div className="flex flex-col items-center justify-center text-2xl font-medium lg:text-4xl md:py-16 lg:p-0">
        <p className='font-bold'>{t('see_how_easy')}</p>
        <Arrow
          variant="rounded"
          className="hidden w-16 h-16 m-4 text-black transform rotate-180 lg:block sm:rotate-180 md:rotate-90"
          direction="up"
        />
      </div>
      <div className="mx-auto ">
        <PointsLine line={line} />
      </div>
    </div>
  )
}

export default WithLineSection
